import { Link } from "react-router-dom";
import { Settings } from "lucide-react";
import { useCurrentBillingPeriod } from "@/hooks/useBillingPeriod";
import { useInvoices } from "@/hooks/useInvoices";
import { IconButton } from "@/components/ui/IconButton";
import { BillingSummaryBar } from "./BillingSummaryBar";

export function TopBar() {
  const { data: period } = useCurrentBillingPeriod();
  const { data: invoices } = useInvoices(period?.period_id ?? null);
  const sent = invoices?.filter((i) => i.status === "sent").length ?? 0;
  const total = invoices?.length ?? 0;

  return (
    <header className="sticky top-0 z-30 h-12 flex items-center gap-3 px-3 bg-bg-elevated border-b border-border">
      <Link to="/" className="flex items-center gap-1.5 text-sm font-semibold shrink-0">
        <span className="size-2 bg-accent rounded-sm" />
        flatRent
      </Link>
      <div className="flex-1 min-w-0">
        <BillingSummaryBar period={period} sentCount={sent} totalCount={total} />
      </div>
      <Link to="/settings" className="shrink-0">
        <IconButton label="Ustawienia"><Settings className="size-4" /></IconButton>
      </Link>
    </header>
  );
}
